export default "__VITE_ASSET__f266e80f__"